import 'flowbite'
import Pristine from 'pristinejs'

import './application.css'

const navbarTarget = document.getElementById('navbar-default')
const navbarExpand = document.getElementById('navbar-expand')
const navbarCollapse = document.getElementById('navbar-collapse')

const collapse = new Collapse(navbarTarget, navbarExpand, {})

navbarCollapse.addEventListener('click', (event) => {
    collapse.collapse()
})

window.addEventListener('click', (event) => {
    if (
        !collapse._visible ||
        navbarExpand === event.target ||
        navbarExpand.contains(event.target)
    ) {
        return
    }
    if (!navbarTarget.contains(event.target)) {
        collapse.collapse()
    }
})

Pristine.addMessages('nl', {
    required: 'Dit veld is verplicht',
})
Pristine.addMessages('de', {
    required: 'Dieses Feld ist erforderlich',
})
Pristine.addMessages('fr', {
    required: 'Ce champ est obligatoire',
})

window.onload = () => {
    Pristine.setLocale(document.documentElement.lang)

    const form1 = document.getElementById('new_certificate')
    const form2 = document.getElementById('new_leveranciers_verklaring')

    setForm(form1)
    setForm(form2)

    function setForm(form) {
        if (form === null) {
            return
        }
        const pristine = new Pristine(
            form,
            {
                errorTextClass: 'pl-6 mt-2 text-red',
            },
            false
        )

        const expiryDateDD = form.querySelector("#expiry_date_dd")
        const expiryDateMM = form.querySelector('#expiry_date_mm')
        const expiryDateYY = form.querySelector('#expiry_date_yy')


        pristine.addValidator(
            expiryDateYY,
            (val) => {
                const day = expiryDateDD.value
                const month = expiryDateMM.value
                const dateString = `${val}-${month}-${day}`
                const expiryDate = Date.parse(dateString)
                const today = new Date()
                today.setHours(0, 0, 0, 0)

                if (expiryDate && expiryDate >= today) {
                    form.querySelector('#expiry_date').value = dateString
                    return true
                }
                form.querySelector('#expiry_date').value = null
                return false
            },
            () => expiryDateYY.dataset.invalidDateMessage,
            50,
            false
        )

        form.addEventListener('submit', (event) => {
            const valid = pristine.validate()
            if (!valid) {
                event.preventDefault()
            }
        })

        form.querySelector('#submitCertificateButton').addEventListener("click", () => {
            const valid = pristine.validate()
            if (valid) {
                form.submit()
            }
        });
    }
}
